import { ComponentType, ComponentInstance } from "../../js/component";

class Alert extends ComponentInstance {
  static selectors = {
    dismiss: '[data-action="dismiss"]',
  };

  init() {
    this.key = this.buildStorageKey(this.el);

    if (this.wasDismissed()) {
      this.forceDismiss();
      return;
    }

    this.open();
    this.bindDismiss();
  }

  open() {
    this.el.hidden = false;
    this.el.dataset.open = "true";
  }

  bindDismiss() {
    this.dismissBtn = this.el.querySelector(Alert.selectors.dismiss);
    if (!this.dismissBtn) return;

    this.dismissHandler = () => this.onDismiss();
    this.dismissBtn.addEventListener("click", this.dismissHandler);
  }

  forceDismiss() {
    this.el.removeAttribute("data-open");
    this.el.hidden = true;
  }

  hide() {
    this.el.removeAttribute("data-open");

    this.el.addEventListener(
      "animationend",
      () => {
        this.el.hidden = true;
      },
      { once: true },
    );
  }

  onDismiss() {
    this.persistDismissed();
    this.hide();
  }

  persistDismissed() {
    if (!this.hasStorage()) return;

    try {
      localStorage.setItem(this.key, "1");
    } catch {}
  }

  wasDismissed() {
    if (!this.hasStorage()) return false;

    try {
      return localStorage.getItem(this.key) === "1";
    } catch {
      return false;
    }
  }

  hasStorage() {
    return typeof window !== "undefined" && "localStorage" in window;
  }

  buildStorageKey(el) {
    const raw =
      el.getAttribute("data-alert-key") ??
      (el.textContent || "").trim().slice(0, 64);

    return `dismissed.${raw}`;
  }

  remove() {
    if (!this.dismissBtn || !this.dismissHandler) return;

    this.dismissBtn.removeEventListener("click", this.dismissHandler);
  }
}

new ComponentType(Alert, "alert", ".alert");
